module.exports = __webpack_public_path__ + "static/img/jiantou2.f17ed2e4.svg";